<template>
    <div class="PjanNavigationbar">
        <div class="tab_content" v-show="highcourt">
            <div class="tab_sent sent"  @click="substance('/newxf')">
                <p>宪法知识</p>
                <span>2023-12-04</span>
            </div>
            <div class="tab_sent" @click="substance('/newsx')">
                <p>失信被执行人和限制高消费的区别</p>
                <span>2023-12-04</span>
            </div>
            <div class="tab_sent" @click="substance('/newyh')">
                <p>只有银行转账凭证，借贷关系如何认定？</p>
                <span>2023-11-13</span>
            </div>
            <div class="tab_sent" @click="substance('/newzy')">
                <p>中央金融工作会议释放重要信号</p>
                <span>2023-11-02</span>
            </div>
            <div class="tab_sent" @click="substance('/newfy')">
                <p>最高人民法院 司法部 联合召开全国调解工作会议</p>
                <span>2023-10-14</span>
            </div>
            <div class="tab_sent" @click="substance('/newtj')">
                <p>金融纠纷调解：高效、经济、可控的解决方案</p>
                <span>2023-10-08</span>
            </div>
            <div class="tab_sent" @click="substance('/newwd')">
                <p>网贷是否受到法律保护呢？</p>
                <span>2023-09-25</span>
            </div>
            <div class="tab_sent" @click="substance('/newyq')">
                <p>逾期利息的最新规定是什么</p>
                <span>2023-09-19</span>
            </div>
            <div class="tab_sent" @click="substance('/newdy')">
                <p>最高人民法院网站发布《关于全面推进金融纠纷多元化解机制的意见》全文</p>
                <span>2023-09-11</span>
            </div>
            <div class="tab_sent" @click="substance('/newrm')">
                <p>全国人民代表大会常务委员会关于授权最高人民法院在部分地区开展民事诉讼程序繁简分流改革试点工作的决定</p>
                <span>2023-09-04</span>
            </div>
            <div class="tab_sent" @click="substance('/newkj2')">
                <p>最高人民法院发布民事诉讼程序繁简分流改革试点问答口径（二）</p>
                <span>2023-08-29</span>
            </div>
            <div class="tab_sent" @click="substance('/newkj1')">
                <p>最高人民法院印发《民事诉讼程序繁简分流改革试点问答口径（一）》</p>
                <span>2023-08-22</span>
            </div>
            <div class="tab_sent" @click="substance('/newzh')">
                <p>如何做好金融/商事纠纷案件的调解工作</p>
                <span>2023-08-15</span>
            </div>
            <div class="tab_sent" @click="substance('/newbh')">
                <p>最高人民法院 金融借款的年利率超过4倍LPR的是否还受保护？</p>
                <span>2023-08-08</span>
            </div>
            <div class="tab_sent" @click="substance('/newbj')">
                <p>司法实践中金融借贷利息、罚息、复利和违约金等的合理边界</p>
                <span>2023-07-31</span>
            </div>
            <div class="tab_sent" @click="substance('/newtz')">
                <p>最高人民法院 中国人民银行 中国银行保险监督管理委员会 印发《关于全面推进金融纠纷多元化解机制建设的意见》的通知</p>
                <span>2023-05-25</span>
            </div>
            <div class="tab_sent" @click="substance('/newbg')">
                <p>最高人民法院工作报告（全文）</p>
                <span>2023-05-25</span>
            </div>
            <div class="tab_sent" @click="substance('/newbm')">
                <p>十四届全国人大一次会议在京闭幕 习近平发表重要讲话</p>
                <span>2023-05-25</span>
            </div>
            <div class="tab_sent" @click="substance('/newxp')">
                <p>良法善治开新篇——以习近平同志为核心的党中央引领建设中国特色社会主义法治体系纪实</p>
                <span>2023-05-25</span>
            </div>
            <!-- <div class="tab_sent">
                <p>调解为债务人节省了约600多万元诉讼费</p>
                <span></span>
            </div> -->
        </div>
        <router-view v-show="!highcourt"/>
    </div>
</template>
<script>
export default {
    data() {
        return {
            highcourt:true
        }
    },
    methods:{
        substance(data){
            // this.highcourt = false
            if(data == this.$route.path) return
            this.$router.push(data)
        }
    },
    watch:{
        $route(to,from){
            if(to.path == '/XwdtNavigationbar'){
                this.highcourt = true
            }else{
                this.highcourt = false
            }
        }
    }
}
</script>
<style lang="less" scoped>
.PjanNavigationbar{
    width: 100%;
    .tab_content{
        p{
            width: 250px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .tab_sent:hover p,.tab_sent:hover span{
            color:#BE1A0F;
        }
    }
}
</style>
